import React, {Component, useState, useEffect} from 'react';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, errorInfo: null};
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Caught an error:", error, errorInfo);
        this.setState({errorInfo});
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h1>Something went wrong.</h1>;
        }
        return this.props.children;
    }
}

const MyEditor = ({onChange, value, placeholder}) => {
    const [editor, setEditor] = useState(null);
    const [isUpdatingValue, setIsUpdatingValue] = useState(false);
    const [lastValue, setLastValue] = useState(value);
    const isEditor = global?.isEditor;

    useEffect(() => {
        if (!editor) return;

        try {
            if (!isEditor) {
                global.e = editor;
                editor.enableReadOnlyMode('my-feature-id');
            }

            // Проверяем наличие всех необходимых свойств
            if (editor?.ui?.view?.toolbar?.element) {
                editor.ui.view.toolbar.element.style.display = 'none';

                // Добавляем обработчик изменений только если модель доступна
                if (editor?.model?.document) {
                    editor.model.document.on('change', () => {
                        const selection = editor.model.document.selection;
                        const toolbarElement = editor.ui.view.toolbar.element;

                        if (selection && !selection.isCollapsed) {
                            toolbarElement.style.display = 'block';
                        } else {
                            toolbarElement.style.display = 'none';
                        }
                    });
                }
            }
        } catch (error) {
            console.error('Error setting up editor:', error);
        }
    }, [editor, isEditor]);

    // Обработка изменения value извне (смена языка)
    useEffect(() => {
        if (editor && value !== lastValue) {
            setIsUpdatingValue(true);
            setLastValue(value);
            
            // Проверяем что редактор полностью инициализирован
            if (editor.model && editor.model.document && editor.model.document.root) {
                // Обновляем содержимое редактора
                const currentData = editor.getData();
                if (currentData !== value) {
                    try {
                        editor.setData(value || '');
                    } catch (error) {
                        console.error('Error setting editor data:', error);
                    }
                }
            }
            
            // Сбрасываем флаг после небольшой задержки
            setTimeout(() => {
                setIsUpdatingValue(false);
            }, 100);
        }
    }, [value, editor, lastValue, isUpdatingValue]);

    value = value || '';

    return (
        <ErrorBoundary>
            <div style={{marginTop: '15px', marginBottom: '20px'}} data-editor-wrapper className={!isEditor ? 'readonly-ck' : ''}>
                <CKEditor
                    config={{
                        placeholder,
                        toolbar: {
                            items: [
                                'bold',
                                'italic',
                                '|',
                                'bulletedList',
                                'numberedList',
                                'link',
                                '|',
                                'undo',
                                'redo'
                            ]
                        },
                    }}
                    isReadOnly={!isEditor}
                    editor={ClassicEditor}
                    data={value}
                    onReady={editorInstance => {
                        // Проверяем что редактор полностью инициализирован
                        if (editorInstance && editorInstance.model && editorInstance.model.document) {
                            setEditor(editorInstance);
                        } else {
                            console.error('CKEditor not properly initialized');
                        }
                    }}
                    onChange={(event, editor) => {
                        try {
                            // Не вызываем onChange если это программное обновление (смена языка)
                            if (isUpdatingValue) {
                                return;
                            }
                            
                            const data = editor.getData();
                            onChange(data);
                        } catch (error) {
                            console.error('Error in onChange:', error);
                        }
                    }}
                />
            </div>
        </ErrorBoundary>
    );
}

export default MyEditor;


// export default function Editor(props) {
//     const {value, onChange, placeholder} = props;
// const [isOpen, setIsOpen] = React.useState(false)
// const handleToolbarFocus = (v, b) => {
//     clearTimeout(_timer)
//     _timer = setTimeout(() => {
//         setIsOpen(v)
//     }, 200)
// }
//   return (
//     <div className={isOpen ? 'toolabar-visible' : 'toolbar-hidden33'} style={{marginTop: '10px'}}>
//       <CKEditor
//         placeholder={placeholder}
//         editor={ClassicEditor}
//         data={value}
//     onReady={(editor) => {
//       console.log('CKEditor React Component is ready to use!', editor);
//       const toolbarElement = editor.ui.view.toolbar.element;

// toolbarElement.addEventListener('focus', () => handleToolbarFocus(true), true);
// toolbarElement.addEventListener('blur', () => handleToolbarFocus(false), true);

//       // CKEditorInspector.attach(editor);
//     }}
//     onBlur={() => {
//         handleToolbarFocus(false, 1)
//     }}
//     onFocus={() => {
//         handleToolbarFocus(true, 1)

//     }}
// onChange={(event, editor) => {
//   const data = editor.getData();
//   console.log('CKEditorChange', { event, editor, data });
//   onChange(data)
// }}
//       />
//     </div>
//   );
// }

